

export default class Youtube {
    constructor(apiClient) { 
        // 외부로 주입받아 오기
        this.apiClient = apiClient;
    }
    // this.httpClient = axios.create({
    //         baseURL: 'https://www.googleapis.com/youtube/v3',
    //         params: { key: process.env.REACT_APP_YOUTUBE_API_KEY },
    //     })

    async search(keyword) {
    return keyword ? this.#searchByKeyword(keyword) : this.#mostPopular();
    }

    async channelImageURL(id) {
        return this.apiClient
            .channels({ params: { part: 'snippet', id }})
            .then((res) => res.data.items[0].snippet.thumbnails.default.url); 
    }
    // channelid로 검색 했을 때 items>snippet>url을 받아온다.

    async #searchByKeyword(keyword) {
    return this.apiClient
      .search({
        params: {
          part: 'snippet',
          maxResults: 25,
          type: 'video',
          q: keyword,
        },
      })
      .then((res) =>
        res.data.items.map((item) => ({ ...item, id: item.id.videoId }))
      );
  }
    async searchByChannelId(channelId){
        return this.apiClient
            .playlist({
                params: {
                    part: 'snippet',
                    maxResults: 25,
                    type: 'video',
                    channelId,
                },
            })
            .then((res) =>
            res.data.items);
    }

    async relatedVideos(id) {
        return this.apiClient.search({
            params: {
                part: 'snippet',
                maxResults: 25,
                type: 'video',
                relatedToVideoId: id,
            },
        })
            .then((res) => 
                res.data.items.map((item) => ({...item, id: item.id.videoId})));
            // 원하는 형태의 id로 반환을 해준다.
    }
    async #mostPopular() {
        return this.apiClient.videos({  
            params: {
                    part: 'snippet',
                    maxResults: 25,
                    chart: 'mostPopular',
                    regionCode: 'KR',
                },
        })
        .then((res) => res.data.items);
    }
}